import useSWR from "swr";
import { environment } from "../config/environment";
import { useSWRFetcher } from "./useSWRFetcher";
import { Mailbox } from "@attelas/shared";

export const useMailboxIntegrations = () => {
  const fetcher = useSWRFetcher();
  const { data, isLoading, error } = useSWR<Mailbox>(`${environment.apiUrl}/api/mailboxes`, fetcher);

  return {
    mailboxIntegrations: data,
    isLoading,
    isError: !!error,
  };
};
